const EL = '.jumbo-video-cover';
const RATIO = 3

class JumboVideoCover {
  constructor() {
    if(document.querySelector(EL)) {
      document.addEventListener("mousemove", this.move)
    }
  }

  move = (e) => {
    const elem = document.querySelector(EL);

    let x = Math.floor(e.clientX / RATIO);
    let y = Math.floor(e.clientY / RATIO);

    elem.style.transform = 'translate('+-x+'px, '+-y+'px)';
  };
}

new JumboVideoCover();
